import {UserSchema} from '../types';

export const userValidator = (value: unknown): boolean => UserSchema.safeParse(value).success;
